import { render, staticRenderFns } from "./helpfulDetail.vue?vue&type=template&id=df7c8d22&scoped=true"
import script from "./helpfulDetail.vue?vue&type=script&lang=js"
export * from "./helpfulDetail.vue?vue&type=script&lang=js"
import style0 from "./helpfulDetail.vue?vue&type=style&index=0&id=df7c8d22&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df7c8d22",
  null
  
)

export default component.exports